import { render, staticRenderFns } from "./DetailedProviderRow.vue?vue&type=template&id=f290ddda&scoped=true"
import script from "./DetailedProviderRow.vue?vue&type=script&lang=js"
export * from "./DetailedProviderRow.vue?vue&type=script&lang=js"
import style0 from "./DetailedProviderRow.vue?vue&type=style&index=0&id=f290ddda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f290ddda",
  null
  
)

export default component.exports